export function extractNestedFields<T>(dataItem: T, columns: any[]): any {
  return columns.reduce(
    (transformedItem, column) => {
      const formattedColumn = column.getColumnContent(dataItem);

      return {...transformedItem, ...formattedColumn};
    },
    {_id: dataItem['_id']}
  );
}

export function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export function transformKeys<T>(obj: T): any {
  if (Array.isArray(obj)) {
    return obj.map(v => transformKeys(v));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((result, key) => {
      result[camelToSnakeCase(key)] = transformKeys(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

export function replaceNullOrUndefined(entity: any): any {
  const result = {};
  for (const key in entity) {
    if (entity.hasOwnProperty(key)) {
      result[key] = entity[key] ?? '';
    } else {
      result[key] = '';
    }
  }
  return result;
}

export function getObjectWithMaxTags(updatedNodes: any[]): any {
  return updatedNodes.reduce((maxObj, currentObj) => {
    return currentObj['tags']?.length > maxObj['tags']?.length ? currentObj : maxObj;
  }, updatedNodes[0]);
}
